var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7 29.5C5.4 29.5 3.6 28.7 2.1 27.1C0.7 25.5 0 23 0 20C0 15.5 1.1 11.6 3.4 8.4C5.7 5.2 9.2 2.6 14 0.5L17.1 7.5C14.1 8 11.5 9 9.3 10.5C7.27115 11.7326 5.74694 13.6467 5 15.9C5.7 15.6 6.7 15.4 7.8 15.4C10 15.4 11.8 16.1 13.1 17.4C14.4 18.7 15.1 20.4 15.1 22.5C15.1 24.6 14.4 26.3 13.1 27.6C12.3825 28.2821 11.5339 28.8111 10.6055 29.155C9.67722 29.4988 8.68867 29.6502 7.7 29.6V29.5ZM26.7 29.5C24.4 29.5 22.5 28.7 21.1 27.1C19.7 25.5 19 23.1 19 20C19 15.5 20 11.6 22.4 8.4C24.7 5.2 28 2.6 32.8 0.5L36 7.5C33 8 30.3 9 28.1 10.5C26.127 11.7253 24.6421 13.5992 23.9 15.8C24.7 15.5 25.6 15.3 26.7 15.3C28.9 15.3 30.7 16 32 17.3C33.4 18.6 34 20.3 34 22.4C34 24.5 33.4 26.2 32 27.5C31.2944 28.1697 30.4621 28.6916 29.5519 29.0351C28.6417 29.3785 27.6721 29.5366 26.7 29.5Z",
    fill: "#BE2A52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationMark);
export default __webpack_public_path__ + "static/media/quotation_mark.59b330d6eb95159ec47716dd1f08cf73.svg";
export { ForwardRef as ReactComponent };